module.exports = __webpack_public_path__ + "img/Feature.636efd9f.png";